import { useCallback } from "react";
import { Close } from "../../Icons";
import style from "./index.module.css";

const Modal = ({ children, onClose }: componentProps) => {
  const onCloseHandler = useCallback(
    (e: any) => {
      if (
        e.target.classList.contains(style.main_modal) ||
        e.target.closest(`.${style.main_modal__close_btn}`)
      ) {
        onClose();
      }
    },
    [onClose]
  );

  return (
    <div className={style.main_modal} onClick={onCloseHandler}>
      <div className={style.main_modal__container}>
        <button
          className={style.main_modal__close_btn}
          onClick={onCloseHandler}
        >
          <Close width="13" height="13" color="#000" />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;

type componentProps = {
  children: any;
  onClose: any;
};
